import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

const PublicLinkTab = ({ publicLink }) => {
  const copyToClipboard = () => {
    navigator.clipboard.writeText(publicLink);
  };
  return (
    <Fragment>
      <div className="title">Enlace para incrustar en web:</div>
      <div className="public-link-tap">
        <div className="link-text">
          {publicLink}
        </div>
        <button type="button" onClick={copyToClipboard} className="copy-link-button" aria-label="Copy Link">Copiar
          enlace
        </button>
      </div>
    </Fragment>
  );
};

PublicLinkTab.propTypes = {
  publicLink: PropTypes.string.isRequired,
};

export default PublicLinkTab;
